import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SUPPRESS_API_ERROR_ALERT } from './api-error-options';
import { AlertsService } from '../../core/services/alerts.service';

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const alertsService = inject(AlertsService);

    return next(req).pipe(
        catchError(err => {
            if (err?.status >= 500 && !req.context.get(SUPPRESS_API_ERROR_ALERT)) {
                alertsService.error('Server error. Please try again later.');
            }
            return throwError(() => err);
        }),
    );
};
